import { render, staticRenderFns } from "./StoryIssueList.vue?vue&type=template&id=3b06130a&scoped=true"
import script from "./StoryIssueList.vue?vue&type=script&lang=js"
export * from "./StoryIssueList.vue?vue&type=script&lang=js"
import style0 from "./StoryIssueList.vue?vue&type=style&index=0&id=3b06130a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b06130a",
  null
  
)

export default component.exports